import React, { useRef } from "react";
import { DoctorCard } from "./DoctorCard";

function DoctorListSection({ doctorList }) {
    const containerRef = useRef(null);

    // Set the scroll amount in pixels
    const scrollAmount = 500; // Adjust this value to your desired scroll amount

    const handleScroll = (direction) => {
        const container = containerRef.current;
        if (container) {
            const scrollDirection =
                direction === "left" ? -scrollAmount : scrollAmount;
            container.scrollBy({ left: scrollDirection, behavior: "smooth" });
        }
    };
    const scrollButtonStyles = {
        boxShadow: "0px 0px 4px 4px rgba(0, 0, 0, 0.08",
        borderRadius: "6px",
        backgroundColor: "rgba(255, 255, 255, 1)",
        border: "none",
    };

    const isMobile = window.innerWidth <= 768;
    return (
        <div className="d-flex w-100 align-items-center mt-4 my-lg-5 flex-column">
            <div className="d-flex justify-content-between w-100 ">
              <div className="f600-16px" style={{color:"rgba(0, 55, 113, 1)"}}>
                {doctorList?.length} Available on Selected Date
              </div>
              {!isMobile && (
                <div className="d-flex align-items-center gap-2">
                <button
                    style={scrollButtonStyles}
                    onClick={() => handleScroll("left")}
                    className="scroll-button"
                >
                    <svg
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8 1L1 7.5L8 14"
                            stroke="#CCCCCC"
                            stroke-linecap="square"
                        />
                    </svg>
                </button>
                <button
                    style={scrollButtonStyles}
                    onClick={() => handleScroll("right")}
                    className="scroll-button"
                >
                    <svg
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1 14L8 7.5L1 1"
                            stroke="#CCCCCC"
                            stroke-linecap="square"
                        />
                    </svg>
                </button>

              </div>
              )}
            </div>
            <div
                className="doctor-list-section d-flex gap-3 gap-lg-4 overflow-auto"
                ref={containerRef}
            >
                {doctorList?.map((doctor) => (
                    <DoctorCard key={doctor.id} doctor={doctor} />
                ))}
            </div>
        </div>
    );
}

export default DoctorListSection;
